<span class="flag-icon" [style]="style"></span>
